import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const Container = styled.div`
  align-items: center;
  display: inline-flex;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(1)}px;
  }
`
